<template>
  <Html lang="en" dir="ltr">
    <Body>
      <TransitionFade>
        <div class="stage" v-if="route.name === 'index' && !ready">
          <Preloader :is-loading="isLoading" @ready="ready = true" />
        </div>
      </TransitionFade>
      <div>
        <NuxtLoadingIndicator :color="'#424091'" :height="4" />
        <ContactUs/>
        <Navbar/>
        <Sidebar/>
        <div :data-theme="theme">
          <NuxtPage @onLoaded="isLoading = false" />
        </div>
        <Footer class="relative"/>
      </div>
    </Body>
  </Html>
</template>

<script setup>
await preloadComponents('preloader');
const route = useRoute();
useHead({
  script: [
    {
      key: 'prevent-script',
      children: `
          window.addEventListener("nuxt-booster:run", function (e) {
            if (!e.detail.sufficient) {
              // added style class to display the content
              document.querySelector('.stage').classList.add('hidden')
            }
          });
        `,
    },
  ],
});
// const THEMES = [
//   'light',
//   'dark',
// ];
const theme = ref(null);
const isLoading = ref(true);
const ready = ref(false);
watch(theme, (value) => {
  localStorage.setItem('daisyui-theme', value);
});
onMounted(() => {
  theme.value = localStorage.getItem('daisyui-theme') || 'light';
});
</script>
